// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar__container {
    min-height: 100vh;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}
.logo__wrapper {
    margin-bottom: 0.75rem;
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity, 1))
}
.logo {
    font-size: 1.5rem;
    line-height: 2rem;
    text-transform: uppercase
}
.sidebar__row {

}
.sidebar__item--wrapper {
    padding-left: 1rem;
    padding-right: 1rem
}
`, "",{"version":3,"sources":["webpack://./src/components/global/Sidebar/sidebar.css"],"names":[],"mappings":"AACI;IAAA,iBAA4B;IAA5B,kBAA4B;IAA5B;AAA4B;AAG5B;IAAA,sBAAmF;IAAnF,aAAmF;IAAnF,YAAmF;IAAnF,WAAmF;IAAnF,mBAAmF;IAAnF,uBAAmF;IAAnF,wBAAmF;IAAnF,sBAAmF;IAAnF;AAAmF;AAGnF;IAAA,iBAAyB;IAAzB,iBAAyB;IAAzB;AAAyB;AAE7B;;AAEA;AAEI;IAAA,kBAAW;IAAX;AAAW","sourcesContent":[".sidebar__container {\n    @apply min-h-screen bg-white;\n}\n.logo__wrapper {\n    @apply w-full h-full flex items-center justify-center border-b mb-3 border-gray-100;\n}\n.logo {\n    @apply uppercase text-2xl;\n}\n.sidebar__row {\n\n}\n.sidebar__item--wrapper {\n    @apply px-4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
